import { useEffect } from 'react';
import { mountVercelToolbar } from '@vercel/toolbar/vite';

export function VercelToolbar() {
  useEffect(() => {
    if (import.meta.env.DEV) {
      mountVercelToolbar();
    }
  }, []);

  return null;
}
